export default __webpack_public_path__ + "static/7_23-ac9fb2037db52fb8f403ff762419b3ed.png";